import poster from '@/static/assets/reviews/DanielGartshein/video.jpg';
import subs from '@/static/assets/reviews/DanielGartshein/subs.vtt';
import { ASSETS_URL, ReviewProduct, ReviewType, VideoReview } from '../../types';

export const DanielGartshein: VideoReview = {
  type: ReviewType.Video,
  product: [ReviewProduct.Pet],
  reviewerName: 'Daniel',
  videoUrl: `${ASSETS_URL}/pet/DanielGartshein_Pet.webm`,
  posterUrl: poster,
  captionsUrl: subs,
};
